import React, { useMemo, memo } from 'react'

// Create optimized pure component
const MediaSkeleton = memo(({ index = 0 }) => {
  // Generate a random height based on the index, so it remains consistent
  // between renders for the same skeleton item
  const randomHeight = useMemo(() => {
    // Use a prime number for better distribution
    const seed = (index * 9973) % 16
    return 15 + seed // Range from 15rem to 30rem
  }, [index])

  return (
    <div className="animate-pulse transform transition-opacity">
      <div
        className="w-full bg-gray-200 rounded-md"
        style={{ height: `${randomHeight}rem` }}
        role="status"
        aria-label="Loading..."
      ></div>
    </div>
  )
})

// Set displayName for React DevTools
MediaSkeleton.displayName = 'MediaSkeleton'

export default MediaSkeleton
